import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import './animation.css';

import FormVideo from '../pages/form/FormVideo';
import FormParticipants from '../pages/form/FormParticipants';
import FormAge from '../pages/form/FormAge';
import FormAgeIndividual from '../pages/form/FormAgeIndividual';
import FormBasic from '../pages/form/FormBasic';
import FormPlans from '../pages/form/FormPlans';
import FormParticipantsNegative from '../pages/form/FormParticipantsNegative';
import FormEnd from '../pages/form/FormEnd';
import FormPreferences from '../pages/form/FormPreferences';
import FormCurrentPlan from '../pages/form/FormCurrentPlan';
import FormChoices from '../pages/form/FormChoices';
import FormUrgency from '../pages/form/FormUrgency';
import FormContact from '../pages/form/FormContact';

const RoutesJS = () => {
  const location = useLocation(); // Hook para acessar a localização atual

  return (
    <TransitionGroup component={null}>
      {' '}
      {/* component={null} é necessário para não adicionar um elemento DOM extra */}
      <Routes location={location}>
        <Route path="/" element={<Navigate to="/simulacao/1" />} />
        <Route path="/simulacao/1" element={<FormVideo />} />
        <Route path="/simulacao/2" element={<FormParticipants />} />
        <Route path="/simulacao/2b" element={<FormParticipantsNegative />} />
        <Route path="/simulacao/3" element={<FormAge />} />
        <Route path="/simulacao/3b" element={<FormAgeIndividual />} />
        <Route path="/simulacao/4" element={<FormPreferences />} />
        <Route path="/simulacao/5" element={<FormBasic />} />
        <Route path="/simulacao/6" element={<FormCurrentPlan />} />
        <Route path="/simulacao/7" element={<FormUrgency />} />
        <Route path="/simulacao/8" element={<FormContact />} />
        <Route path="/simulacao/9" element={<FormEnd />} />
        <Route path="/simulacao/11" element={<FormPlans />} />
      </Routes>
    </TransitionGroup>
  );
};

export default RoutesJS;
